<template>
  <div>
    <div class="page-header navbar navbar-fixed-top">
        <!-- BEGIN HEADER INNER -->
        <div class="page-header-inner">
            <!-- BEGIN LOGO -->
            <div class="page-logo">

            </div>
            <div class="quiz-title text-center">
              <h2 v-if="quiz && quiz.title">{{quiz.title}}</h2>
              <h2 v-else>Erreur</h2>
            </div>
        </div>
    </div>

    <div class="row m-0 page-404-full-page" v-if="quiz && error == ''">
      <div class="page-404 pb-100 col-xs-12">

        <div class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3" v-show="question_index < 0">
          <a href="">
              <img src="../../assets/logo_transferh_full.png" alt="logo" class="logo-default" />
          </a>
          <h1 class="uppercase mt-50">Merci de répondre à nos questions</h1><br>

          <div>
            <form id="startQuiz" class="absolute-parlsey-errors">
              <div class="form-group form-md-line-input" style="margin-top:30px;">
                <label class="col-md-3 control-label">Prénom
                  <span class="required" aria-required="true">*</span>
                </label>
                  <div class="col-md-8">
                      <input type="text" class="form-control" v-model="response.firstname" required>
                      <div class="form-control-focus"> </div>
                  </div>
              </div>
              <div class="form-group form-md-line-input" style="margin-top:50px;">
                <label class="col-md-3 control-label">Nom
                  <span class="required" aria-required="true">*</span>
                </label>
                  <div class="col-md-8">
                      <input type="text" class="form-control" v-model="response.lastname" required>
                      <div class="form-control-focus"> </div>
                  </div>
              </div>
              <div class="form-group form-md-line-input" style="margin-top:50px;">
                <label class="col-md-3 control-label">Date de naissance
                  <span class="required" aria-required="true">*</span>
                </label>
                  <div class="col-md-8">
                      <input class="form-control form-control-inline date-picker" id="date_birthday" type="text" value="" required>
                      <div class="form-control-focus"> </div>
                      <span class="help-block">Cette information est demandée pour éviter les doublons dans les réponses.</span>
                  </div>
              </div>

              <div class="col-xs-12 mt-50">
                <span class="required" style="color:#6b500f" aria-required="true">**</span> <em> Ces informations ne seront pas utilisées à des fins commerciales.</em>
              </div>



              <a v-on:click="startQuiz()" class="btn green mt-50">Répondre aux questions</a>
            </form>

            <div class="text-left note note-info mt-30" v-if="quiz.instructions != ''">
              <h4 class="block"> Bienvenue, </h4>
              <h5>Merci de lire ces instructions avant de répondre aux questions : </h5>
              <div style="color:#4f4f4f">{{quiz.instructions}}</div>
            </div>

          </div>

        </div>


        <!-- DEBUT DES QUESTIONS DU FORMULAIRE -->
        <div class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3" v-if="question_index >= 0 && question_index < quiz.questions.length">
          <h1>Question n°{{question_index+1}}</h1><br>
          <em class="question_title">{{quiz.questions[question_index].title}}</em><br><br>
          <div v-if="quiz.questions[question_index].description" class="mb-20"><em>{{quiz.questions[question_index].description}}</em></div>
          <form :id="'question'+question_index" class="absolute-parlsey-errors">
            <div class="form-group form-md-line-input col-xs-12" style="margin-top:0px;margin-bottom:40px;">
              <label class="col-md-2 control-label">Réponse
                <span class="required" aria-required="true">*</span>
              </label>
                <!-- <div class="col-md-10" v-if="quiz.questions[question_index].type == 'select'">
                    <select type="text" class="form-control" :id="'question'+quiz.questions[question_index].slug" v-model="response.questions[question_index].value" :required="response.questions[question_index].noResponse != true">
                      <option v-for="data in quiz.questions[question_index].data" :value="data.value">{{data.name}}</option>
                    </select>
                    <div class="form-control-focus"> </div>
                </div> -->
                <!-- <div class="col-md-10" v-if="quiz.questions[question_index].type == 'radio'">
                    <input type="text" class="form-control" :id="'question'+quiz.questions[question_index].slug" v-model="response.questions[question_index].value" :required="response.questions[question_index].noResponse != true">
                    <div class="form-control-focus"> </div>
                </div> -->
                <div class="col-md-10" v-if="quiz.questions[question_index].type == 'checkbox' || quiz.questions[question_index].type == 'checkbox_multiple'">
                    <div class="mt-checkbox-list text-left">
                        <label class="mt-checkbox" v-for="(data,d_index) in quiz.questions[question_index].data"> {{data.name}}
                            <input type="checkbox" :id="'question'+quiz.questions[question_index].id" :value="data.name" name="check[]" v-model="response.questions[question_index].value" v-on:change="inputChange(question_index)" :required="response.questions[question_index].noResponse != true">
                            <span></span>
                        </label>
                    </div>
                </div>
                <div class="col-md-10" v-if="quiz.questions[question_index].type == 'radio' || quiz.questions[question_index].type == 'radio_multiple'">
                    <div class="mt-radio-list text-left">
                        <label class="mt-radio" v-for="(data,d_index) in quiz.questions[question_index].data"> {{data.name}}
                            <input type="radio" :id="'question'+quiz.questions[question_index].id" :value="data.name" name="radio[]" v-model="response.questions[question_index].value" v-on:change="inputChange(question_index)" :required="response.questions[question_index].noResponse != true">
                            <span></span>
                        </label>
                    </div>
                </div>
                <div class="col-md-10" v-if="quiz.questions[question_index].type == 'scale'">
                    <div class="mt-radio-inline">
                        <div style="display:none;">{{response.questions[question_index].scaleRange}}</div>
                        <label class="mt-radio" style="padding:5px;" v-for="(scale,scale_index) in response.questions[question_index].scaleRange">
                            <input type="radio" name="optionsRadios[]" :id="'question'+quiz.questions[question_index].id" :value="scale" v-model="response.questions[question_index].value" v-on:change="inputChange(question_index)" :required="response.questions[question_index].noResponse != true">
                            <div class="num_scale">{{scale}}</div>
                            <span></span>
                        </label>
                    </div>
                </div>
                <!-- <div class="col-md-10" v-if="quiz.questions[question_index].type == 'date'">
                    // date
                </div> -->
                <div class="col-md-10" v-if="quiz.questions[question_index].type == 'text'">
                    <!-- <input type="text" class="form-control" :id="'question'+quiz.questions[question_index].slug" v-model="response.questions[question_index].value" :required="response.questions[question_index].noResponse[question_index] != true"> -->
                    <textarea type="text" rows="5" class="form-control" placeholder="" :id="'question'+quiz.questions[question_index].id" v-model="response.questions[question_index].value" v-on:change="inputChange(question_index)" :required="response.questions[question_index].noResponse != true"></textarea>
                    <div class="form-control-focus"> </div>
                </div>
                <!-- <div class="col-md-10" v-if="quiz.questions[question_index].type == 'textarea'">
                    <textarea type="text" rows="6" class="form-control" placeholder="" :id="'question'+quiz.questions[question_index].slug" v-model="response.questions[question_index].value" :required="response.questions[question_index].noResponse != true"></textarea>
                    <div class="form-control-focus"> </div>
                </div> -->
                <!-- <div class="col-md-10" v-if="quiz.questions[question_index].type == 'number'">
                    <input type="number" class="form-control" :min="quiz.questions[question_index].min" :max="quiz.questions[question_index].max" :id="'question'+quiz.questions[question_index].slug" v-model="response.questions[question_index].value" :required="response.questions[question_index].noResponse != true">
                    <div class="form-control-focus"> </div>
                </div> -->
            </div>
            <div class="mt-checkbox-inline text-right">
                <label class="mt-checkbox">
                    <input type="checkbox" v-model="response.questions[question_index].noResponse" v-on:change="reValidateInput('question'+quiz.questions[question_index].id,question_index)" value="option1"> <em class="no-response">« Ne se prononce pas »</em>
                    <span></span>
                </label>
            </div>

             <!-- checkbox_multiple  -->
            <div v-if="quiz.questions[question_index].type == 'checkbox_multiple' || quiz.questions[question_index].type == 'radio_multiple'">
              <div v-for="(data2,d) in quiz.questions[question_index].data" v-if="response.questions[question_index].value && response.questions[question_index].value.toString().indexOf(data2.name) >= 0 && data2.question && data2.question.title">
                <em class="question_title">{{data2.question.title}}</em><br><br>
                <div v-if="data2.question.description" class="mb-20"><em>{{data2.question.description}}</em></div>
                <div class="form-group form-md-line-input col-xs-12" style="margin-top:0px;margin-bottom:40px;">
                  <label class="col-md-2 control-label">Réponse
                    <span class="required" aria-required="true">*</span>
                  </label>
                  <div class="col-md-10" v-if="data2.question.type == 'text'">
                      <textarea type="text" rows="5" class="form-control" placeholder="" :id="'question'+d+quiz.questions[question_index].id" v-on:change="inputChange(question_index,d)" v-model="response.questions[question_index].data[d].value" :required="response.questions[question_index].data[d].noResponse != true"></textarea>
                      <div class="form-control-focus"> </div>
                  </div>
                  <div class="col-md-10" v-if="data2.question.type == 'scale'">
                      <div class="mt-radio-inline">
                          <label class="mt-radio" style="padding:5px" v-for="scale in response.questions[question_index].data[d].scaleRange">
                              <input type="radio" :id="'question'+d+quiz.questions[question_index].id" name="optionsRadios3[]" :value="scale" v-on:change="inputChange(question_index,d)" v-model="response.questions[question_index].data[d].value" :required="response.questions[question_index].data[d].noResponse != true">
                              <div class="num_scale">{{scale}}</div>
                              <span></span>
                          </label>
                      </div>
                  </div>
                  <div class="col-md-10" v-if="data2.question.type == 'checkbox'">
                    <div class="mt-checkbox-list text-left">
                        <label class="mt-checkbox" v-for="(data3,d3_index) in data2.question.data"> {{data3.name}}
                            <input type="checkbox" :id="'question'+d+quiz.questions[question_index].id" :value="data3.name" name="check3[]" v-model="response.questions[question_index].data[d].value" v-on:change="inputChange(question_index,d)" :required="response.questions[question_index].data[d].noResponse != true">
                            <span></span>
                        </label>
                    </div>
                  </div>
                  <div class="col-md-10" v-if="data2.question.type == 'radio'">
                    <div class="mt-radio-list text-left">
                        <label class="mt-radio" v-for="(data3,d3_index) in data2.question.data"> {{data3.name}}
                            <input type="radio" :id="'question'+d+quiz.questions[question_index].id" :value="data3.name" name="radio3[]" v-model="response.questions[question_index].data[d].value" v-on:change="inputChange(question_index,d)" :required="response.questions[question_index].data[d].noResponse != true">
                            <span></span>
                        </label>
                    </div>
                  </div>
                </div>
                <div class="mt-checkbox-inline text-right">
                    <label class="mt-checkbox">
                        <input type="checkbox" v-model="response.questions[question_index].data[d].noResponse" v-on:change="reValidateInput('question'+d+quiz.questions[question_index].id,question_index,d)" value="option1"> <em class="no-response">« Ne se prononce pas »</em>
                        <span></span>
                    </label>
                </div>
              </div>
            </div>
            <!-- end checkbox_multiple -->


            <div class="col-xs-12 mt-50">
              <span class="required text-danger" aria-required="true">*</span> <em>Tous les champs sont obligatoires et doivent être remplis pour pouvoir valider le questionnaire.</em>
            </div>
            <div class="col-xs-4 text-left mt-50">
              <a v-on:click="removeError();question_index--" class="btn default">Précédent</a>
            </div>
            <div class="col-xs-4 text-center mt-50">
              {{((question_index+1)/quiz.questions.length*100).toFixed()}}% des questions complétées.
            </div>
            <div class="col-xs-4 text-right mt-50">
              <a v-if="question_index == quiz.questions.length-1" v-on:click="sendQuiz()" class="btn green">Valider et envoyer le questionnaire</a>
              <a v-else v-on:click="validateQuestion()" class="btn green">Suivant</a>
            </div>
          </form>
        </div>

        <div class="col-xs-12 col-md-6 col-md-offset-3" v-if="isFinish">
          <div class="text-left note note-success mt-30">
            <h4 class="block"> Le questionnaire a été validé. </h4>
            <div>{{quiz.conclusion}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-0 page-404-full-page" v-if="!quiz">
      <div class="col-md-12 page-404 pb-100">
          <div class="number font-green"> 404 </div>
          <div class="details">
              <h3>Oops ! Questionnaire non trouvé.</h3>
              <p> Nous n'avons pas réussi à trouver ce questionnaire.
                  <br>
                  Vérifiez l'url et tentez de recharger la page.
              </p>
          </div>
      </div>
    </div>
    <div class="row m-0 page-404-full-page" v-if="error != ''">
      <div class="col-md-12 page-404 pb-100">
          <div class="number error font-green"> Erreur </div>
          <div class="details">
              <h3>Oops ! Une erreur est survenue</h3>
              <p> {{error}}
                  <br>
              </p>
          </div>
      </div>
    </div>

    <!-- BEGIN FOOTER -->
    <div class="page-footer">
        <div class="page-footer-inner mt-10"> 2017 &copy; TransfeRH &nbsp;|&nbsp;
            Site réalisé par <a target="_blank" href="http://lewebfrancais.fr">Le Web Français</a>
        </div>
        <div class="scroll-to-top">
            <i class="icon-arrow-up"></i>
        </div>
    </div>
    <!-- END FOOTER -->

  </div>
</template>

<script>

import quizzes from '../../requests/quizzes.js'
import responses from '../../requests/responses.js'

export default {
  name: 'quizzes_show',
  data () {
    return{
      quiz:{},
      response:{
        firstname:"",
        lastname:"",
        birthday:"",
        groupId:"",
        questions:[]
      },
      question_index:-1,
      isFinish:false,
      error:""
    }
  },
  mounted:function(){
    var parent = this;
    parent.$nextTick(function(){
      $('.date-picker').datepicker({
        format: 'dd/mm/yyyy',
        startView: "decade",
        minViewMode: "day",
        language:'fr'
      });
    })
    if(this.$route.params.slug && this.$route.query && this.$route.query.group){
      // récupérer les groupes.
      parent.$root.$emit('loading', true,true);
      quizzes.getBySlug(parent,parent.$route.params.slug,function(quiz,err){
        if(err){
          parent.$root.$emit('loading', false,false);
          parent.quiz = null;
          toastr.error("Impossible de récupérer le questionnaire "+parent.$route.params.slug+".","ERREUR");
        }
        else{
          if(quiz.groups){
            for(var g=0;g<quiz.groups.length;g++){
              if(quiz.groups[g].slug == parent.$route.query.group){
                parent.response.groupId = quiz.groups[g].id;
              }
            }
            if(quiz.groups.length > 0 && parent.response.groupId == ""){
              parent.$root.$emit('loading', false,false);
              parent.error = "Votre numéro de groupe est invalide.";
              toastr.error("Votre numéro de groupe est invalide.","ERREUR");
              return;
            }
          }

          if(quiz && quiz.state == 'published'){
            var date_isValid = true;
            if(quiz.date_deadline){
              var date_now = new Date();
              date_now.setMinutes(0);
              date_now.setHours(0);
              date_now.setSeconds(0);
              date_now.setMilliseconds(0);
              var date_deadline = new Date(quiz.date_deadline);
              if(date_deadline.getTime() < date_now.getTime()){
                date_isValid = false;
              }
            }
            if(date_isValid){
              quizzes.getQuestions(parent,parent.$route.params.slug,function(questions,err){
                if(questions){
                  parent.quiz = quiz;
                  parent.quiz['questions'] = questions;
                  for(var c=0;c<questions.length;c++){
                      if(questions[c].type == "checkbox_multiple" || questions[c].type == "radio_multiple"){
                        if(parent.quiz.questions[c].type == "checkbox_multiple"){
                          parent.response.questions[c] = {value:[], noResponse:false,data:[]};
                        }
                        else{
                          parent.response.questions[c] = {value:"", noResponse:false,data:[]};
                        }

                        for(var p=0;p<questions[c].data.length;p++){
                          if(questions[c].data[p].question && questions[c].data[p].question.type == 'scale'){
                            var min = questions[c].data[p].question.min && questions[c].data[p].question.min != '' ? questions[c].data[p].question.min : 0;
                            var max = questions[c].data[p].question.max && questions[c].data[p].question.max != '' ? questions[c].data[p].question.max : 10;
                            var i = min < max ? min : max;
                            var scaleRange = [];
                            while(i<=max){
                              scaleRange.push(i);
                              i++;
                            }
                            parent.response.questions[c].data.push({value:"",parentValue:questions[c].data[p].name,noResponse:false,scaleRange:scaleRange});
                          }else if(questions[c].data[p].question && questions[c].data[p].question.type == 'checkbox'){
                            parent.response.questions[c].data.push({value:[],parentValue:questions[c].data[p].name,noResponse:false})
                          }
                          else{
                            parent.response.questions[c].data.push({value:"",parentValue:questions[c].data[p].name,noResponse:false})
                          }
                        }
                      }
                      else if(questions[c].type == "checkbox"){
                        parent.response.questions[c] = {value:[], noResponse:false};
                      }
                      else if(questions[c].type == "scale"){
                        parent.response.questions[c] = {value:"", noResponse:false,scaleRange:[]};
                        var min = questions[c].min && questions[c].min != '' ? questions[c].min : 0;
                        var max = questions[c].max && questions[c].max != '' ? questions[c].max : 10;
                        var i = min < max ? min : max;
                        while(i<=max){
                          parent.response.questions[c].scaleRange.push(i);
                          i++;
                        }
                      }
                      else{
                        parent.response.questions[c] = {value:"", noResponse:false}
                      }


                  }

                  parent.$root.$emit('loading', false,false);

                }
                else{
                  parent.$root.$emit('loading', false,false);
                  parent.error = "Impossible de récupérer les questions du formulaire.";
                  toastr.error("Impossible de récupérer les questions du formulaire.","ERREUR");
                }
              })
            }
            else{
              parent.$root.$emit('loading', false,false);
              parent.error = "La date limite des réponses à ce questionnaire a été dépassée.";
              toastr.error("La date limite des réponses est dépassée. Vous ne pouvez plus répondre à ce questionnaire.","ERREUR");
            }
          }
          else{
            parent.$root.$emit('loading', false,false);
            parent.error = "Ce questionnaire n'est pas publié.";
            toastr.error("Ce questionnaire n'est pas publié.","ERREUR");
          }
        }
      })
    }
    else if(!this.$route.params.slug){
      parent.quiz = null;
    }

    if(!this.$route.query || !this.$route.query.group){
      parent.error = "Impossible de récupérer votre numéro de groupe.";
      toastr.error("Impossible de récupérer votre numéro de groupe.","ERREUR");
    }
  },
  methods:{
    inputChange(question_index,data_index){
      if(data_index != null && question_index != null){
        this.response.questions[question_index].data[data_index].noResponse = false;
      }
      else if(question_index != null){
        this.response.questions[question_index].noResponse = false;
      }
      this.$forceUpdate();
    },
    reValidateInput(id,index,data_index){
      this.$forceUpdate();
      this.$nextTick(function () {
        $("#"+id).parsley().validate();
        // Check si la case a été cochée. Alors réinit les inputs.
        if(index != null){
          if(this.response.questions[index].noResponse){
            if(this.quiz.questions[index].type == "checkbox_multiple" || "checkbox"){
              this.response.questions[index].value = [];
            }
            else{
              this.response.questions[index].value = "";
            }
            if(this.response.questions[index].data){
              for(var d=0;d<this.response.questions[index].data.length;d++){
                if(this.quiz.questions[index].data[d].question.type == "checkbox"){
                  this.response.questions[index].data[d].value = [];
                }
                else{
                  this.response.questions[index].data[d].value = "";
                }
              }
            }
            this.$forceUpdate();
          }
          else if(data_index != null){
            if(this.quiz.questions[index].data[data_index].question.type == "checkbox"){
              this.response.questions[index].data[data_index].value = [];
            }
            else{
              this.response.questions[index].data[data_index].value = "";
            }
            this.$forceUpdate();
          }
        }
      })
    },
    startQuiz(){
      $("#startQuiz").parsley().validate();
      if($("#startQuiz").parsley().isValid()){
        var parent = this;
        var birthday = $("#date_birthday").datepicker("getDate");
        responses.isAuthorized(this,this.quiz.slug,this.response.groupId, this.response.firstname,this.response.lastname,birthday,function(err){
          if(err){
            toastr.error(err,"ERREUR");
          }
          else{
            parent.question_index++;
          }
        })
      }
    },
    sendQuiz(){
      $("#question"+this.question_index).parsley().validate();
      if($("#question"+this.question_index).parsley().isValid()){
        // this.question_index++;
        this.$forceUpdate();
        var parent = this;
        this.response.birthday = $("#date_birthday").datepicker("getDate");
        quizzes.createResponses(this,this.quiz.slug,this.response,function(rep,err){
          if(rep){
            parent.question_index++;
            parent.isFinish = true;
          }
          else{
            toastr.error(err,"ERREUR");
          }
        })
      }
    },
    validateQuestion(){
      $("#question"+this.question_index).parsley().validate();
      if($("#question"+this.question_index).parsley().isValid()){
        this.question_index++;
      }
    },
    removeError(){
      $("#question"+this.question_index).parsley().reset();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .question_title{
    font-size: 25px;
  }

  .no-response{
    color:gray;
  }

  .logo-default{
    max-width:300px;
    max-height: 200px;
    margin-top:-30px!important;
  }

  .page-header.navbar{
    height: 60px;
  }

  .page-header-inner h2{
    color:white;
  }

  .quiz-title{
    display: block;
    width:500px;
    position: relative;
    top: -5px;
    margin:auto;
  }

  .note-info{
    background-color: #ececec;
  }

</style>

<style src="../../assets/theme/css/error.min.css"></style>



// WEBPACK FOOTER //
// show.vue?b5698222